let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFEXu")).then(() => parcelRequire('Uhlgd'));